import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Jun/2026: productos de prueba (TEST/PYTEST/LEGACY o familia TEST) no deben
// aparecer en los buscadores del armador de pedidos (escritorio y móvil).
const _TEST_RE = /^(TEST|PYTEST|LEGACY)/i;
export function esProductoDePrueba(p) {
  if (!p) return false;
  return _TEST_RE.test(String(p.nombre || "")) || _TEST_RE.test(String(p.sku || "")) ||
    /^PYT-/i.test(String(p.sku || "")) || String(p.familia_key || "").trim().toUpperCase() === "TEST";
}
